"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidFieldValidationType = void 0;
var FluidFieldValidationType;
(function (FluidFieldValidationType) {
    FluidFieldValidationType["REQUIRED"] = "required";
    FluidFieldValidationType["MIN_LENGTH"] = "minLength";
    FluidFieldValidationType["MAX_LENGTH"] = "maxLength";
    FluidFieldValidationType["MIN_VALUE"] = "minValue";
    FluidFieldValidationType["MAX_VALUE"] = "maxValue";
    FluidFieldValidationType["PATTERN"] = "pattern";
    FluidFieldValidationType["DAYS_BEFORE"] = "daysBefore";
    FluidFieldValidationType["DAYS_AFTER"] = "daysAfter";
    FluidFieldValidationType["IS_AFTER_FIELD"] = "isAfterField";
    FluidFieldValidationType["IS_BEFORE_FIELD"] = "isBeforeField";
    FluidFieldValidationType["MAX_DATE"] = "maxDate";
    FluidFieldValidationType["MIN_DATE"] = "minDate";
    FluidFieldValidationType["DEPENDENT"] = "dependent";
    FluidFieldValidationType["CUSTOM"] = "custom";
    FluidFieldValidationType["MIN_ENTRIES"] = "minEntries";
    FluidFieldValidationType["MAX_ENTRIES"] = "maxEntries";
    FluidFieldValidationType["INVALID_ENTRIES"] = "invalidEntries";
})(FluidFieldValidationType = exports.FluidFieldValidationType || (exports.FluidFieldValidationType = {}));
